module.exports = __webpack_public_path__ + "media/images/front/dr_nakamura_s-14b7b440f6b2fb55a0a7d8f61eb4bc11.jpg";